import { render, staticRenderFns } from "./join.vue?vue&type=template&id=fa55151c&scoped=true"
import script from "./join.vue?vue&type=script&lang=js"
export * from "./join.vue?vue&type=script&lang=js"
import style0 from "./join.vue?vue&type=style&index=0&id=fa55151c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa55151c",
  null
  
)

export default component.exports